import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axiosInstance from './utils/axiosInstance';
import { removeAuthToken, setAuthToken } from './utils/storageUtil';
import { errorDialog } from './utils/dialog';
import { LockOutlined, UserOutlined } from '@ant-design/icons';
import { Button, Form, Input } from 'antd';

const LoginPage: React.FC = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const navigate = useNavigate();

    const loginUser = async (username: string, password: string) => {
        try {
            const response = await axiosInstance.post("admin/login", {
                username,
                password,
            })
            if (response?.data?.token) {
                setAuthToken(response?.data?.token);
                navigate('/user');
            } else {
                errorDialog('账号或密码错误');
            }

        } catch (error: any) {
            console.error('Error fetching data:', error);
            if (error?.response?.status === 401) {
                navigate('/login');  // Redirect to login if unauthorized
            }
        }
    };

    const onFinish = async (values: any) => {
        console.log('Received values of form: ', values);
        await loginUser(values.username, values.password);
    };

    useEffect(() => {
        removeAuthToken();
    }, [])

    return (
        <div
            className="flex min-h-screen w-full items-center justify-center px-4
                       bg-[radial-gradient(1100px_520px_at_50%_-10%,#eef2ff_0%,#f8fafc_55%)]"
        >
            <div className="w-full max-w-[380px] animate-fade-up">
                <div className="mb-7 flex flex-col items-center">
                    <div
                        className="mb-4 flex h-12 w-12 items-center justify-center rounded-[13px]
                                   bg-brand text-[21px] font-bold text-white shadow-glow
                                   transition-transform duration-300 ease-smooth hover:scale-105"
                    >
                        A
                    </div>
                    <h1 className="m-0 text-[21px] font-semibold text-ink">Admin</h1>
                    <p className="mb-0 mt-1.5 text-[13px] text-muted">请登录以继续</p>
                </div>

                <div className="rounded-[14px] border border-line bg-white p-6
                                shadow-[0_4px_16px_-4px_rgb(15_23_42/0.08)]
                                transition-shadow duration-300 hover:shadow-lifted">
                    <Form
                        name="login"
                        layout="vertical"
                        requiredMark={false}
                        initialValues={{ remember: true }}
                        onFinish={onFinish}
                    >
                        <Form.Item
                            name="username"
                            label="用户名"
                            rules={[{ required: true, message: '请输入用户名' }]}
                        >
                            <Input size="large" prefix={<UserOutlined className="text-faint" />} placeholder="用户名" />
                        </Form.Item>
                        <Form.Item
                            name="password"
                            label="密码"
                            rules={[{ required: true, message: '请输入密码' }]}
                        >
                            <Input size="large" prefix={<LockOutlined className="text-faint" />} type="password" placeholder="密码" />
                        </Form.Item>

                        <Form.Item className="!mb-0 !mt-6">
                            <Button block size="large" type="primary" htmlType="submit">
                                登录
                            </Button>
                        </Form.Item>
                    </Form>
                </div>
            </div>
        </div>
    );
};

export default LoginPage;
